import type { CSSProperties } from "react";
import heroImage from "@/assets/panduankafe_hero.webp";
import heroImageMobile from "@/assets/panduankafe_hero_mobile.webp";
import { trackEvent } from "@/lib/analytics";

const HeroSection = () => {
  const handlePrimaryCta = () =>
    trackEvent("cta_click", {
      cta_location: "hero",
      cta_label: "Konsultasi Gratis Sekarang",
      cta_target: "/#lead-form",
    });

  const handleSecondaryCta = () =>
    trackEvent("cta_click", {
      cta_location: "hero",
      cta_label: "Lihat Cara Kerjanya",
      cta_target: "/#sinergy",
    });

  return (
    <section
      className="relative min-h-[calc(100vh-4rem)] flex items-center overflow-hidden"
      style={
        {
          "--hero-bg-desktop": `url('${heroImage}')`,
          "--hero-bg-mobile": `url('${heroImageMobile}')`,
        } as CSSProperties
      }
    >
      <div
        className="absolute inset-0 z-0 hero-bg-image bg-center bg-cover"
        role="img"
        aria-label="Interior cafe aesthetic dengan pencahayaan hangat dan tanaman hijau"
      >
        <div className="absolute inset-0 bg-gradient-to-b from-espresso/70 via-espresso/45 to-espresso/85" />
      </div>

      {/* Readability scrim: ONE layer (blur + warm dark tint) behind the copy.
          A left-weighted mask keeps the right side of the photo crisp and stays
          responsive on any viewport (percentage-based, no breakpoints). */}
      <div
        aria-hidden="true"
        className="absolute inset-0 z-[1] backdrop-blur-md bg-espresso/35"
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, #000 0%, #000 42%, transparent 72%)",
          maskImage:
            "linear-gradient(to right, #000 0%, #000 42%, transparent 72%)",
        }}
      />

      <div className="container mx-auto relative z-10 py-32">
        <div className="max-w-3xl [text-shadow:0_2px_12px_rgba(0,0,0,0.5)]">
          <p className="fade-in-up uppercase tracking-[0.3em] text-xs text-cream/80 mb-6">
            Panduan &amp; Konsultasi Bisnis Cafe
          </p>
          <h1 className="fade-in-up fade-in-up-delay-1 text-5xl md:text-7xl font-serif font-medium leading-[1.05] text-cream">
            Bangun Cafe yang <em className="italic text-terracotta">Untung</em>, Bukan Sekadar Ikut Hype.
          </h1>
          <p className="fade-in-up fade-in-up-delay-2 mt-8 text-lg md:text-xl text-cream/85 max-w-xl leading-relaxed font-light">
            Panduan Kafe memandu Anda dari konsep sampai profit — lewat konsultasi gratis dan playbook operasional hasil membedah brand-brand besar F&amp;B di Indonesia. Berhenti trial &amp; error yang menguras modal Anda.
          </p>
          <div className="fade-in-up fade-in-up-delay-3 mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#lead-form"
              onClick={handlePrimaryCta}
              className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-terracotta text-primary-foreground font-medium tracking-wide hover:bg-[hsl(var(--primary-hover))] hover:shadow-elevated transition-[var(--transition-smooth)]"
            >
              Konsultasi Gratis Sekarang →
            </a>
            <a
              href="#sinergy"
              onClick={handleSecondaryCta}
              className="inline-flex items-center justify-center px-8 py-4 rounded-full border border-cream/40 text-cream font-medium hover:bg-cream/10 transition-[var(--transition-smooth)]"
            >
              Lihat Cara Kerjanya
            </a>
          </div>

          <div className="fade-in-up fade-in-up-delay-3 mt-16 flex gap-10 text-cream/80">
            <div>
              <div className="font-serif text-3xl text-cream">15+</div>
              <div className="text-xs uppercase tracking-widest mt-1">Brand F&amp;B Dibedah</div>
            </div>
            <div>
              <div className="font-serif text-3xl text-cream">Gratis</div>
              <div className="text-xs uppercase tracking-widest mt-1">Sesi Konsultasi</div>
            </div>
            <div className="hidden sm:block">
              <div className="font-serif text-3xl text-cream">1×24 Jam</div>
              <div className="text-xs uppercase tracking-widest mt-1">Respons Tim Kami</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
